import { Injectable, ComponentRef, Provider } from '@angular/core';
import { IConfirmDialogService, IConfirmDialogServiceToken } from 'shared/services/ui/dialogs/confirm/confirm-dialog-service.abstract';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { ConfirmDialogMHComponent } from '../../components/shared/dialog/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
}) export class ConfirmDialogService implements IConfirmDialogService {

  confirmDialogShow(
    callbackCancel: () => void,
    modalTitle?: string,
    modalText?: string,
    callbackYes?: () => void,
    callbackNo?: () => void,
  ) {
    DialogBaseService.dialogGenericShow(
      ConfirmDialogMHComponent,
      (component: ComponentRef<ConfirmDialogMHComponent>) => {
        component.instance.modalCancel.subscribe(
          () => {
            callbackCancel();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );

        component.instance.modalTitle = modalTitle;
        component.instance.modalText = modalText;

        component.instance.modalYes.subscribe(
          () => {
            callbackYes?.();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.modalNo.subscribe(
          () => {
            callbackNo?.();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
      }
    );
  }

}
/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConfirmDialogServiceProvider: Provider[] = [
  { provide: IConfirmDialogServiceToken, useExisting: ConfirmDialogService }
];

